module.exports = __webpack_public_path__ + "static/demo-critical-ff3eb1986477dd15d4c82eed2b44c711.png";